import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import Input from '../../components/UI/Input';
import Button from '../../components/UI/Button';
import * as authService from '../../services/authService';
import * as validators from '../../utils/validators';

export default function ForgotPassword() {
	const [email, setEmail] = useState('');
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');

	async function onSubmit(e) {
		e.preventDefault();
		if (!validators.validateEmail(email)) {
			setError('Enter a valid email');
			return;
		}
		setError('');
		setLoading(true);
		try {
			await authService.forgotPassword(email);
			toast.success('If the email exists, a reset link has been sent.');
		} catch (err) {
			toast.error(err?.response?.data?.message || 'Request failed');
		} finally {
			setLoading(false);
		}
	}

	return (
		<div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
			<div className="w-full max-w-md bg-white shadow rounded-lg p-6">
				<h1 className="text-2xl font-bold text-center">Forgot Password</h1>
				<form className="mt-6 space-y-4" onSubmit={onSubmit}>
					<Input name="email" label="Email" value={email} onChange={(e) => setEmail(e.target.value)} error={error} required />
					<Button type="submit" loading={loading} className="w-full">
						Send reset link
					</Button>
				</form>
				<p className="mt-4 text-sm text-center">
					Back to{' '}
					<Link to="/login" className="text-primary-600 hover:underline">
						Login
					</Link>
				</p>
			</div>
		</div>
	);
}


